import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@mui/material/Tooltip';
import {styled} from '@mui/system';


const StyledVariants = styled('div')(({ theme }) =>({
    color: theme.custom.color.grey,
    fontSize: theme.custom.font.medium,
    overflow:'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}));


class NameVariants extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.variants && (this.props.variants.last_names || this.props.variants.first_names)){
            let last_names = this.props.variants ? this.props.variants.last_names : '';
            let first_names = this.props.variants ? this.props.variants.first_names : '';
            return (
                <Tooltip title={last_names + ' | ' + first_names} placement="bottom-start">
                    <StyledVariants>{last_names} | {first_names}</StyledVariants>
                </Tooltip>
            );
        }
        return (
            <StyledVariants>&nbsp;</StyledVariants>
        );
    }

}

NameVariants.propTypes = {
    variants: PropTypes.object
};

export default NameVariants;
